module.exports = __webpack_public_path__ + "static/media/filter-tool.8f6e6aed.svg";